import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type UnitItem = Omit<UnitInternalItem, 'version'>;

type UnitInternalItem = {
    readonly version: string;
    readonly id: number;
    readonly name: string;
    readonly symbol: string;
    readonly default: boolean;
    readonly externalId: string;
};

export class UnitQuery extends Query<UnitItem[]> { }

export class UnitQueryHandlerBase implements QueryHandler<UnitQuery, UnitItem[]> {
    private static Url = TaggedUrl.join('products/units', [Tags.Api]);

    public constructor(private readonly http: HttpService) { }

    public async handleAsync(_: UnitQuery): Promise<UnitItem[]> {
        const { data } = await this.http.get<{ items: UnitInternalItem[] }>(UnitQueryHandlerBase.Url);
        return data.items.map(i => ({
            id: i.id,
            name: i.name,
            symbol: i.symbol,
            default: i.default,
            externalId: i.externalId
        }));
    }
}
